import React, { useState } from 'react';
import { Menu, X, Phone, Mail } from 'lucide-react';
import { Button } from './ui/button';

const Header = ({ onGetQuoteClick }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navLinks = [
    { name: 'Home', href: '#home' },
    { name: 'About', href: '#about' },
    { name: 'Services', href: '#services' },
    { name: 'Benefits', href: '#benefits' },
    { name: 'Process', href: '#process' },
    { name: 'Testimonials', href: '#testimonials' },
    { name: 'Contact', href: '#contact' }
  ];

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  return (
    <header className="sticky top-0 z-50 bg-white/95 backdrop-blur-md shadow-sm border-b border-ep-green/20">
      <div className="container mx-auto px-4 md:px-8">
        {/* Top bar */}
        <div className="hidden md:flex items-center justify-end gap-6 py-2 text-sm border-b border-gray-100">
          <a href="tel:9011555048" className="flex items-center gap-2 text-gray-600 hover:text-ep-teal transition-colors">
            <Phone className="w-4 h-4" />
            9011555048
          </a>
          <a href="mailto:connect@ektapower.com" className="flex items-center gap-2 text-gray-600 hover:text-ep-teal transition-colors">
            <Mail className="w-4 h-4" />
            connect@ektapower.com
          </a>
        </div>

        {/* Main header */}
        <div className="flex items-center justify-between py-4">
          {/* Logo */}
          <div className="flex items-center">
            <img
              src="/logo.png"
              alt="Ekta Power & Green Energy Systems"
              className="h-16 md:h-20 w-auto object-contain"
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-8">
            {navLinks.map((link) => (
              <button
                key={link.name}
                onClick={() => scrollToSection(link.href)}
                className="text-gray-700 hover:text-ep-green font-medium transition-colors"
              >
                {link.name}
              </button>
            ))}
          </nav>

          {/* CTA Button & Mobile Menu Toggle */}
          <div className="flex items-center gap-4">
            <Button
              onClick={onGetQuoteClick}
              className="hidden md:flex ep-shimmer-btn text-white font-semibold shadow-lg ep-glow-green"
            >
              Get Free Quote
            </Button>
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="lg:hidden p-2 text-gray-700 hover:text-ep-green transition-colors"
              aria-label="Toggle menu"
            >
              {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="lg:hidden bg-white border-t border-gray-100 shadow-lg">
          <nav className="container mx-auto px-4 py-4 flex flex-col gap-4">
            {navLinks.map((link) => (
              <button
                key={link.name}
                onClick={() => scrollToSection(link.href)}
                className="text-left text-gray-700 hover:text-ep-green font-medium py-2 transition-colors"
              >
                {link.name}
              </button>
            ))}
            <Button
              onClick={() => {
                onGetQuoteClick();
                setIsMenuOpen(false);
              }}
              className="ep-shimmer-btn text-white font-semibold w-full"
            >
              Get Free Quote
            </Button>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
